import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Product accordion block: updates description/spec/share content when the variant changes
 * (section HTML includes updated product context).
 */
class ProductInfoAccordions extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateAccordions);
    initReadMoreWrappers(this);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateAccordions);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateAccordions = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = String(event.detail.data.newProduct.id);
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const doc = event.detail.data.html;
    const productId = this.dataset.productId;
    const blockId = this.dataset.blockId;

    /** @type {Element | null} */
    let newContainer = null;
    if (productId && blockId) {
      newContainer = doc.querySelector(
        `product-info-accordions[data-product-id="${productId}"][data-block-id="${blockId}"] [ref="accordionsContainer"]`
      );
    }
    if (!newContainer && productId) {
      newContainer = doc.querySelector(
        `product-info-accordions[data-product-id="${productId}"] [ref="accordionsContainer"]`
      );
    }
    if (!newContainer) {
      newContainer = doc.querySelector('product-info-accordions [ref="accordionsContainer"]');
    }

    const currentContainer = this.querySelector('[ref="accordionsContainer"]');
    if (!newContainer || !currentContainer) return;

    if (currentContainer.innerHTML !== newContainer.innerHTML) {
      currentContainer.replaceWith(newContainer.cloneNode(true));
      initReadMoreWrappers(this);
    }
  };
}

/**
 * Read-more / gradient reveal for description accordion (runs after initial render and after variant swap).
 * @param {ParentNode} root
 */
function initReadMoreWrappers(root) {
  const wrappers = root.querySelectorAll('[data-read-more-wrapper]');
  for (const wrapper of wrappers) {
    if (!(wrapper instanceof HTMLElement)) continue;

    const btn = wrapper.querySelector('[data-read-more-btn]');
    const gradient = wrapper.querySelector('[data-read-more-gradient]');
    if (!btn || !gradient) continue;

    const maxHeight = Number.parseInt(getComputedStyle(wrapper).getPropertyValue('--read-more-max-height'), 10);
    if (!Number.isFinite(maxHeight) || maxHeight <= 0) continue;

    const contentHeight = wrapper.scrollHeight;
    if (contentHeight <= maxHeight + 4) {
      gradient.style.display = 'none';
      continue;
    }

    btn.addEventListener('click', () => {
      wrapper.classList.add('is-expanded');
    });
  }
}

if (!customElements.get('product-info-accordions')) {
  customElements.define('product-info-accordions', ProductInfoAccordions);
}
